import styled from 'styled-components'

const FileChooser = styled.div`
    min-height: 460px;
    background: #FFFFFF;

    display: flex;
    flex-direction: column;

    font-family: Roboto, sans-serif;
    font-style: normal;
    font-weight: normal;

    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.15);
    border-radius: 8px;

    @media (max-width: 481px) {
        width: 96vw;
        // min-height: 470px;
    }

    @media (min-width: 481px) and (max-width: 641px) {
        width: 459px;
        min-height: 440px;
    }

    @media (min-width: 641px) and (max-width: 961px) {
        width: 621px;
        // min-height: 428px;
    }

    @media (min-width: 961px) and (max-width: 1201px) {
        width: 759px;
    }

    @media (min-width: 1201px) {
        width: 759px;
    }
`

export default FileChooser